import { useQuery } from '@tanstack/react-query'

import { CommonService } from '@/services/common.service'

import { PLATFORM_API_MAP } from '@/constants/common'
import { TPlatformValue } from '@/types/uploadForm.interface'

const TAGS_CACHE_TTL = 1000 * 60 * 60

export const useTags = (platform?: TPlatformValue | null) => {
	const config = platform ? PLATFORM_API_MAP[platform] : undefined

	const { data: tags = [] } = useQuery({
		queryKey: ['tags', config?.source, config?.lang],
		queryFn: () => CommonService.getTags(config.source, config.lang),
		enabled: Boolean(config),
		staleTime: TAGS_CACHE_TTL,
		cacheTime: TAGS_CACHE_TTL,
		select: response =>
			response?.tags?.map(tag => ({
				label: tag.name,
				value: String(tag.id)
			})) ?? [],
		onError: error => {
			console.error('Error loading tags:', error)
		}
	})

	return tags
}
